import { API_BASE_URL } from "../config"

export type CampoDinamico = {
  key: string
  label: string
  type: "text" | "number" | "date" | "textarea" | "select"
  required?: boolean
  options?: string[]
}

export type TipoBeneficio = {
  id: number
  nombre: string
  descripcion: string
  documentos_requeridos: string[]
  dias_procesamiento: string
}

type FormularioDinamicoResponse = {
  beneficio: TipoBeneficio
  campos: CampoDinamico[]
}

type SolicitudPayload = {
  nombreCompleto: string
  email: string
  identificacion: string
  numeroSeguridadSocial: string
  beneficioId: number
  descripcionSolicitud: string
  camposDinamicos: Record<string, string>
  archivos: File[]
}

async function parseError(response: Response) {
  try {
    const payload = await response.json()
    return payload.detalle || "No se pudo procesar la solicitud."
  } catch {
    return "No se pudo procesar la solicitud."
  }
}

export async function obtenerTiposBeneficio(token?: string) {
  const headers: HeadersInit = {}
  if (token) headers["Authorization"] = `Token ${token}`

  const response = await fetch(`${API_BASE_URL}/module2/tipos-beneficio`, { headers })
  if (!response.ok) {
    throw new Error("No se pudieron cargar los tipos de beneficio.")
  }
  return (await response.json()) as TipoBeneficio[]
}

export async function obtenerFormularioBeneficio(beneficioId: number, token?: string) {
  const headers: HeadersInit = {}
  if (token) headers["Authorization"] = `Token ${token}`

  const response = await fetch(`${API_BASE_URL}/module2/formulario-beneficio/${beneficioId}`, { headers })
  if (!response.ok) {
    throw new Error("No se pudo cargar el formulario dinamico.")
  }
  return (await response.json()) as FormularioDinamicoResponse
}

export async function crearSolicitudBeneficio(payload: SolicitudPayload, token: string) {
  const formData = new FormData()
  formData.append("nombre_completo", payload.nombreCompleto)
  formData.append("email", payload.email)
  formData.append("identificacion", payload.identificacion)
  formData.append("numero_seguridad_social", payload.numeroSeguridadSocial)
  formData.append("benefit_type_id", String(payload.beneficioId))
  formData.append("descripcion_solicitud", payload.descripcionSolicitud)
  formData.append("campos_dinamicos", JSON.stringify(payload.camposDinamicos))

  payload.archivos.forEach((file) => {
    formData.append("archivos", file)
  })

  const response = await fetch(`${API_BASE_URL}/module2/solicitudes-beneficio`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }

  return response.json() as Promise<{
    mensaje: string
    tracking_id: string
    estado: string
  }>
}

export async function obtenerHistorialSolicitudes(token: string) {
  const response = await fetch(`${API_BASE_URL}/module2/mis-solicitudes`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}

export async function actualizarDocumentosSolicitud(token: string, solicitudId: number, archivos: File[]) {
  const formData = new FormData()
  archivos.forEach((file) => {
    formData.append("archivos", file)
  })

  const response = await fetch(`${API_BASE_URL}/module2/solicitudes-beneficio/${solicitudId}/documentos`, {
    method: "POST",
    headers: {
      Authorization: `Token ${token}`,
    },
    body: formData,
  })

  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}